import * as Models from "../Models";

export interface IAssociatedEpcCalculationTableDirectiveScope extends ng.IScope {
    contractOptionTileDirective: AssociatedEpcCalculationTableDirective;
    epcCalculationOptions: Models.CostCalculation.EpcCalculationOptionsByProduct.IEpcCalculationOptionByProduct[];
}

export class AssociatedEpcCalculationTableDirective implements ng.IDirective {
    public restrict = "E";
    public scope = {
        epcCalculationOptions: "=",
        canViewEpcPrice: "=",
        product: "=",
        isPending: "="
    };

    public template = require("./associated-epc-calculation-table.html");

    public $scope: IAssociatedEpcCalculationTableDirectiveScope;
    public $state: angular.ui.IStateService;

    public epcCalculationOptions: Models.CostCalculation
        .EpcCalculationOptionsByProduct.IEpcCalculationOptionByProduct[];
    public canViewEpcPrice: boolean;

    public static $inject = [
        "$state"
    ];

    constructor(
        $state: angular.ui.IStateService
    ) {
        this.$state = $state;
    }

    public link = (
        $scope: IAssociatedEpcCalculationTableDirectiveScope,
        elm: any,
        attr: any,
        ctrl: any
    ): void => {
        $scope.contractOptionTileDirective = this;
        this.$scope = $scope;
    };
}